import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'
import sperowPharmaLogo from './assets/SPEROW-PHARMA-LOGO.png'

// Set tab favicon using the Sperow Pharma logo
const existingFavicon = document.querySelector("link[rel~='icon']") || document.createElement('link')
existingFavicon.rel = 'icon'
existingFavicon.type = 'image/png'
existingFavicon.href = sperowPharmaLogo
if (!existingFavicon.parentNode) {
  document.head.appendChild(existingFavicon)
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
